// Collection Product Cards functionality - matching home page behavior
document.addEventListener('DOMContentLoaded', function() {
  // Handle variant selection
  const variantSelects = document.querySelectorAll('.collection-variant-select');
  
  variantSelects.forEach(select => {
    select.addEventListener('change', function() {
      const productId = this.dataset.productId;
      const selectedOption = this.options[this.selectedIndex];
      const variantId = selectedOption.value;
      const price = selectedOption.dataset.price;
      const image = selectedOption.dataset.image;
      
      const card = this.closest('.collection-product-card');
      
      // Update price
      const priceElement = card.querySelector('.collection-product-price');
      if (priceElement && price) {
        // Format price using Shopify's money format
        const formattedPrice = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'GBP',
          minimumFractionDigits: 2
        }).format(price / 100);
        priceElement.textContent = formattedPrice;
        priceElement.dataset.price = price;
      }
      
      // Update image if variant has one
      const productImage = card.querySelector('.collection-product-image');
      if (productImage && image) {
        productImage.src = image;
      }
      
      // Update add to cart button variant ID
      const addToCartBtn = card.querySelector('.collection-add-to-cart-btn');
      if (addToCartBtn) {
        addToCartBtn.dataset.variantId = variantId;
      }

      // Update checkbox variant ID for bulk selection
      const checkbox = card.querySelector('.product-select-checkbox');
      if (checkbox) {
        checkbox.dataset.variantId = variantId;
        // If checkbox was checked, update the selection in bulk add to cart
        if (checkbox.checked && window.bulkAddToCart) {
          // Trigger change event to update the selection
          const event = new Event('change', { bubbles: true });
          checkbox.dispatchEvent(event);
        }
      }

      // Update product card variant ID
      card.dataset.variantId = variantId;
    });
  });
  
  // Handle add to cart functionality
  const addToCartButtons = document.querySelectorAll('.collection-add-to-cart-btn');
  
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const variantId = this.dataset.variantId;
      const productId = this.dataset.productId;
      
      if (!variantId) {
        console.error('No variant ID found');
        return;
      }
      
      // Add loading state
      this.classList.add('loading');
      this.disabled = true;
      
      // Add to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        // Remove loading state
        this.classList.remove('loading');
        this.disabled = false;
        
        if (data.status && data.status === 422) {
          // Handle error (out of stock, etc.)
          alert(data.description || 'Unable to add item to cart');
        } else {
          // Success - update cart
          this.textContent = 'Added!';
          setTimeout(() => {
            this.textContent = 'Add to Cart';
          }, 2000);
          
          // Trigger cart update events
          if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {source: 'collection-product-card', productVariantId: variantId});
          }

          // Update sticky cart count
          if (typeof window.updateStickyCart === 'function') {
            window.updateStickyCart();
          }

          // Don't auto-open cart drawer - only open when clicking cart icon
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        this.classList.remove('loading');
        this.disabled = false;
        alert('Error adding item to cart. Please try again.');
      });
    });
  });
  
  // Prevent clicks on variant selectors from triggering product link
  const variantSelectors = document.querySelectorAll('.collection-variant-selector');
  variantSelectors.forEach(selector => {
    selector.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  });
  
  // Prevent clicks on buttons from triggering product link
  const buttons = document.querySelectorAll('.collection-add-to-cart-btn');
  buttons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  });
});

// Reinitialize when new products are loaded via infinite scroll
document.addEventListener('shopify:section:load', function() {
  // Re-run the initialization for newly loaded content
  setTimeout(() => {
    const event = new Event('DOMContentLoaded');
    document.dispatchEvent(event);
  }, 100);
});
